<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.subjects?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.subjects' | translate }}</span>
</div>
<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.sessions?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.sessions' | translate }}</span>
</div>
<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.acquisitions?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.acquisitions' | translate }}</span>
</div>
<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.acquisition_files?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.acquisitionFiles' | translate }}</span>
</div>
<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.analyses?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.analyses' | translate }}</span>
</div>
<div class="statistic-panel">
  <span *ngIf="!loading" class="statistic">{{ statistics?.jobs?.toLocaleString() || 0 }}</span>
  <span *ngIf="!loading" class="stat-label">{{ 'common.labels.jobs' | translate }}</span>
</div>
